// extracted by mini-css-extract-plugin
module.exports = {"container":"EditableValue_container__2Hepi","button":"EditableValue_button__1CY8A","saveButton":"EditableValue_saveButton__1yPqb"};